export { default } from "./withInsightsPrivileges";
